import { render, staticRenderFns } from "./portalSso.vue?vue&type=template&id=51c0f198&"
import script from "./portalSso.vue?vue&type=script&lang=js&"
export * from "./portalSso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports